import { gql } from '@apollo/client'

const BrandDetailsFragment = gql`
  fragment BrandDetailsFragment on Brand {
    id
    autoeatId
    name
    website
    status
    isPublished
    isDeleted
    isFake
    locationCount
    updatedAt
    createdAt
    originalBrandId
    useBrandNameAsLocationName

    mainLocationType {
      id
      name
    }

    cuisineType {
      id
      name
    }

    additionalLocationTypes {
      id
      name
    }
  }
`

export default BrandDetailsFragment
